export const FONT = {
	fontWeight: {
		regular: 400,
		semibold: 600,
		bold: 700,
		medium: 500
	},
	size: {
		h1: "2rem",
		h2: "1.5rem",
		h3: "1.25rem",
		display1: "3rem",
		display2: "2.5rem",
		large: "1.125rem",
		default: "1rem",
		small1: "0.9375rem",
		small2: "0.875rem",
		smaller1: "0.8125rem",
		smaller2: "0.75rem",
		smaller3: "0.625rem"
	}
} as const